import deburr from "lodash/deburr";
import axios from "axios";
import React, {Component} from "react";
import AutocompleteSearch from "./AutocompleteSearch";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import MenuItem from "@material-ui/core/MenuItem";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core";
import _ from 'lodash';
import {urlConfig} from './config'
const styles = theme => ({});

class ContentSearch extends Component {

    handleClipSearchRequest = (value) => {

        const inputValue = deburr(value.trim()).toLowerCase();

        let serverUrl = `${urlConfig.bffUrl}/video/getSearchResults?keyword=`;

        const caas2Instance = axios.create({
            baseURL: `${serverUrl}${inputValue}`,
            timeout: 120000,
            headers: {'ACCEPT': 'application/vnd.vuclip.cms.v2+json;charset=UTF-8'}
        });

        return caas2Instance.get()

    };

    getSuggestions = (value, suggestions) => {
        const inputValue = deburr(value.trim()).toLowerCase();
        const inputLength = inputValue.length;
        let count = 0;

        return inputLength === 0
            ? []
            : _.filter(suggestions, (suggestion => {
                const keep =
                    count < 5 && suggestion._source.shorttitle.slice(0, inputLength).toLowerCase() === inputValue;

                if (keep) {
                    count += 1;
                }

                return keep;
            }));
    };

    getSuggestionValue = (suggestion) => {
        return suggestion._source.shorttitle;
    };

    renderSuggestion = (suggestion, {query, isHighlighted}) => {
        const matches = match(suggestion._source.shorttitle, query);
        const parts = parse(suggestion._source.shorttitle, matches);

        return (
            <MenuItem selected={isHighlighted} component="div">
                <div>
                    {_.map(parts, ((part, index) => {
                        return part.highlight ? (
                            <span key={String(index)} style={{fontWeight: 500}}>
              {part.text}
            </span>
                        ) : (
                            <strong key={String(index)} style={{fontWeight: 300}}>
                                {part.text}
                            </strong>
                        );
                    }))}
                </div>
            </MenuItem>
        );
    };

    handleSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
        let suggestionValueParsed = suggestion._source.cid;

        this.props.handleSuggestionSelect(suggestionValueParsed, suggestion);
    };

    render() {
        return (<AutocompleteSearch
            inputSearchText={this.props.inputSearchText}
            handleSuggestionSelect={this.props.handleSuggestionSelect}
            handleSuggestionSelected={this.handleSuggestionSelected}
            handleSearchRequest={this.handleClipSearchRequest}
            inputPlaceholder={'Search with Clip Title here'}
            getSuggestions={this.getSuggestions}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}/>)
    }
}


ContentSearch.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};
export default withStyles(styles, {withTheme: true})(ContentSearch);